import { ShopInstance } from '@/store'

const paymentLink = {
  state: {
    url: '',
    order_id: '',
    customerInformation: false,
    payment_methods: {
      pix_enabled: false,
      credit_card_enabled: true,
      boleto_enabled: false
    },
    paymentLinkStatus: 'products-services',
    name: null,
    max_paid_sessions: null,
    expiresIn: null,
    expiresInValue: null,
    expiresInPeriod: null,
    selectedExpiresIn: null,
    cartSettings: {
      shippingCost: 0,
      items: [{
        name: null,
        description: null,
        amount: 0,
        default_quantity: 1,
        shipping_cost: 0
      }]
    },
    customer_settings: {
      customer: {
        name: null,
        email: null
      }
    },
    boleto_settings: {
      has_discount: false,
      due_in: 3,
      discount: 10,
      discount_type: null
    },
    pix_settings: {
      has_discount: false,
      expires_in: 1,
      discount: 10,
      discount_type: null
    },
    credit_card_settings: {
      statement_descriptor: null,
      operation_type: 'auth_and_capture',
      rated_installments: 0,
      max_installments: 12,
      free_installments: 0,
      interest_rate: 0.00,
      customer_fee: true
    }
  },
  getters: {
    creditCardSettings (state) {
      return state.credit_card_settings
    },
    paymentLinkStatus (state) {
      return state.paymentLinkStatus
    },
    paymentMethods (state) {
      return state.payment_methods
    },
    paymentLinkItems (state) {
      return state.cartSettings.items
    },
    paymentLinkShipping (state) {
      return state.cartSettings.shippingCost
    },
    customerData (state) {
      return state.customer_settings.customer
    },
    paymentLinkData (state) {
      return state
    }
  },
  mutations: {
    'CHANGE_STATUS' (state, status) {
      state.paymentLinkStatus = status
    },
    'SHIPPING_VALUE' (state, value) {
      state.cartSettings.shippingCost = value
    },
    'CREDIT_CARD_PAYMENT' (state, value) {
      state.payment_methods.credit_card_enabled = value
    },
    'PIX_PAYMENT' (state, value) {
      state.payment_methods.pix_enabled = value
    },
    'BOLETO_PAYMENT' (state, value) {
      state.payment_methods.boleto_enabled = value
    },
    'UPDATE_ITEM' (state, params) {
      state.cartSettings.items[params.index][params.attribute] = params.value
    },
    'UPDATE_DATA' (state, params) {
      state[params.attribute] = params.value
    },
    'UPDATE_CUSTOMER_DATA' (state, params) {
      state.customer_settings.customer[params.attribute] = params.value
    },
    'UPDATE_CREDIT_CARD_DATA' (state, params) {
      state.credit_card_settings[params.attribute] = params.value
    },
    'UPDATE_PIX_DATA' (state, params) {
      state.pix_settings[params.attribute] = params.value
    },
    'UPDATE_BOLETO_DATA' (state, params) {
      state.boleto_settings[params.attribute] = params.value
    },
    'RESET_PAYMENT_LINK_STATE' (state, params) {
      state.expiresInValue = null
      state.expiresInPeriod = null
      state.selectedExpiresIn = null
      state.url = null
      state.customerInformation = false
      state.payment_methods = {
        pix_enabled: true,
        credit_card_enabled: true,
        boleto_enabled: true
      }
      state.name = null
      state.max_paid_sessions = null
      state.expiresIn = null
      state.cartSettings = {
        shippingCost: 'R$ 0,00',
        items: [{
          name: null,
          description: null,
          amount: 'R$ 0,00',
          default_quantity: 1,
          shipping_cost: 0
        }]
      }
      state.customer_settings = {
        customer: {
          name: null,
          email: null
        }
      }
      state.boleto_settings = {
        has_discount: false,
        due_in: 3,
        discount: 10,
        discount_type: null
      }
      state.pix_settings = {
        has_discount: false,
        expires_in: 24,
        discount: 10,
        discount_type: null
      }
      state.credit_card_settings = {
        statement_descriptor: null,
        operation_type: 'auth_and_capture',
        rated_installments: 0,
        max_installments: 1,
        free_installments: 0,
        interest_rate: 0.00,
        customer_fee: true
      }
    }
  },
  actions: {
    'CREATE_PAYMENT_LINK' (context, params) {
      return ShopInstance.paymentLink.create(params.merchantId, params.accountId, params.body)
    },
    'CHANGE_STATUS' (context, status) {
      context.commit('CHANGE_STATUS', status)
    },
    'SHIPPING_VALUE' (context, value) {
      context.commit('SHIPPING_VALUE', value)
    },
    'CREDIT_CARD_PAYMENT' (context, value) {
      context.commit('CREDIT_CARD_PAYMENT', value)
    },
    'PIX_PAYMENT' (context, value) {
      context.commit('PIX_PAYMENT', value)
    },
    'BOLETO_PAYMENT' (context, value) {
      context.commit('BOLETO_PAYMENT', value)
    },
    'UPDATE_ITEM' (context, params) {
      context.commit('UPDATE_ITEM', params)
    },
    'UPDATE_DATA' (context, params) {
      context.commit('UPDATE_DATA', params)
    },
    'UPDATE_BOLETO_DATA' (context, params) {
      context.commit('UPDATE_BOLETO_DATA', params)
    },
    'UPDATE_PIX_DATA' (context, params) {
      context.commit('UPDATE_PIX_DATA', params)
    },
    'UPDATE_CUSTOMER_DATA' (context, params) {
      context.commit('UPDATE_CUSTOMER_DATA', params)
    },
    'UPDATE_CREDIT_CARD_DATA' (context, params) {
      context.commit('UPDATE_CREDIT_CARD_DATA', params)
    },
    'RESET_PAYMENT_LINK_STATE' (context, params) {
      context.commit('RESET_PAYMENT_LINK_STATE', params)
    }
  }
}

export default paymentLink
